/** Closed vocabularies of the registry (spec A1, A4). */

export const APPS = ['landing', 'crm_v3', 'crm_v2', 'studio_v3', 'studio_v2', 'api'] as const;
export type App = (typeof APPS)[number];

export const AREAS = [
  'landing',
  'auth',
  'onboarding',
  'access',
  'canvas',
  'processors',
  'payment_flows',
  'catalog',
  'orders',
  'subscriptions',
  'customers',
  'integrations',
  'domains',
  'emails',
  'team',
  'settings',
  'billing',
  'experiments',
  'agent',
  'studio',
  'data',
  'ui',
  'nav',
  'api',
] as const;
export type Area = (typeof AREAS)[number];

/** Reserved for later surfaces; no event may use them yet. */
export const RESERVED_AREAS = ['payfac', 'extension'] as const;

export const VERBS = [
  'view',
  'click',
  'submit',
  'open',
  'close',
  'start',
  'complete',
  'fail',
  'cancel',
  'create',
  'update',
  'delete',
  'add',
  'remove',
  'connect',
  'disconnect',
  'publish',
  'deploy',
  'generate',
  'send',
  'invite',
  'export',
  'import',
  'search',
  'select',
  'enable',
  'disable',
  'accept',
  'reject',
  'upload',
  'save',
  'apply',
  'show',
  'deny',
  'switch',
  'verify',
  'play',
  'use',
  'receive',
  'refund',
  'retry',
  'redeem',
  'load',
  'end',
] as const;
export type Verb = (typeof VERBS)[number];

/** `area:object_verb`, lowercase snake_case (A1). */
export const EVENT_NAME_REGEX = /^[a-z][a-z0-9_]*:[a-z0-9]+(_[a-z0-9]+)*$/;

/** Keys that may carry personal data (A3). Matched against non-`$` property keys. */
export const PII_KEY_REGEX =
  /(^|_)(email|phone|first_name|last_name|full_name|address|ip|customer_name|card|iban|query|message|note|search|title)($|_)/;

/** Person `$set` keys allowed despite the denylist: merchant users, never shoppers (A3). */
export const PERSON_PII_EXCEPTIONS = ['email', 'name'] as const;

/** Agent tool domains whose payloads may be sent as-is (E6). */
export const SAFE_AI_DOMAINS = [
  'funnels',
  'products',
  'stores',
  'promotions',
  'taxes',
  'shipping',
  'domains',
  'integrations',
  'billing',
  'account',
  'team',
] as const;
